import { apiClient } from "@/modules/shared/utils/apiClient";

import { RequestSupportData } from "../types/RequestSupportData";

export const requestSupport = (data: RequestSupportData) =>
  apiClient.post("/member/support", data);
